import {int} from "@opendaw/lib-std"

export namespace Euclid {
    // Bresenham distribution: it yields the same necklaces as Bjorklund's algorithm, only rotated, and the
    // rotation is a parameter here anyway.
    export const pattern = (steps: int, pulses: int, rotation: int = 0): ReadonlyArray<boolean> => {
        const result = new Array<boolean>(Math.max(1, steps)).fill(false)
        if (pulses <= 0) {return result}
        if (pulses >= result.length) {return result.fill(true)}
        // Priming the accumulator with the remainder puts the first pulse on step 0 instead of at the end of
        // the first group, so E(4,16) reads as four to the floor.
        let bucket = result.length - pulses
        for (let index = 0; index < result.length; index++) {
            bucket += pulses
            if (bucket >= result.length) {
                bucket -= result.length
                result[index] = true
            }
        }
        if (rotation === 0) {return result}
        const length = result.length
        const offset = ((rotation % length) + length) % length
        return result.map((_, index) => result[(index + offset) % length])
    }
}
